/* eslint-disable no-magic-numbers */

export const dropdownSizes = [
	'large',
	'compact',
] as const;

export type DropdownSize = typeof dropdownSizes[number] | LegacyDropdownSize;

// Pre-redesign names, kept so existing call sites keep compiling.
// ponytail: delete once no consumer passes them.
type LegacyDropdownSize = 'default' | 'small';

export type DropdownSizeDefinition = {
	/** Fixed height of the trigger box. */
	height: number;
	fontSize: number;
	letterSpacing: number;
	iconSize: number;
	/** The label side. Tighter on the right, where the chevron sits. */
	paddingLeft: number;
	paddingRight: number;
	gap: number;
	/** Menu row height. Rows carry the box's type scale, so both read as one size. */
	itemHeight: number;
	menuMaxHeight: number;
};

// Figma draws icons in 24 / 20 / 16 frames. The rebrand glyphs carry the frame's padding
// themselves (drawn on a 24 grid), so the font size is the frame as is.
// ponytail: kept as a ratio so the old icons' 17.8 / 24 is one edit away if the rebrand is rolled back.
const glyphRatio = 1;

export const menuPadding = 4;
export const menuItemPaddingHorizontal = 8;

// Six rows and half of the seventh. The cut row is what tells the user the list
// scrolls — a menu that ends on a whole row looks complete when it is not.
const visibleRows = 6.5;
const menuMaxHeight = (itemHeight: number) =>
	menuPadding + visibleRows * itemHeight;

const large: DropdownSizeDefinition = {
	height: 48,
	fontSize: 18,
	letterSpacing: -0.18,
	iconSize: 24 * glyphRatio,
	paddingLeft: 16,
	paddingRight: 14,
	gap: 4,
	itemHeight: 48,
	menuMaxHeight: menuMaxHeight(48),
};

const compact: DropdownSizeDefinition = {
	height: 36,
	fontSize: 14,
	letterSpacing: 0,
	iconSize: 20 * glyphRatio,
	paddingLeft: 12,
	paddingRight: 10,
	gap: 4,
	itemHeight: 36,
	menuMaxHeight: menuMaxHeight(36),
};

export const DropdownSizes: { [key in DropdownSize]: DropdownSizeDefinition } = {
	large,
	compact,
	default: large,
	small: compact,
};
